import { combineReducers } from "redux";
import tokenReducer from "./authReducer";
import snackbarReducer from "./snackbarReducer";


export default combineReducers({
    auth: tokenReducer,
    snackbar: snackbarReducer
});